export const GRID_VISUAL_SIZE = 10;

export const SCALE_RANGES = [
  { label: "0 - 10", max: 10, supportVisualScale: 1.0, sectionVisualScale: 1.0, loadVisualScale: 1.0 },
  { label: "10 - 20", max: 20, supportVisualScale: 0.5, sectionVisualScale: 0.5, loadVisualScale: 0.5 },
  { label: "20 - 30", max: 30, supportVisualScale: 0.33, sectionVisualScale: 0.33, loadVisualScale: 0.33 },
  { label: "30 - 50", max: 50, supportVisualScale: 0.2, sectionVisualScale: 0.2, loadVisualScale: 0.2 },
  { label: "50 - 100", max: 100, supportVisualScale: 0.1, sectionVisualScale: 0.1, loadVisualScale: 0.1 },
  { label: "100 - 500", max: 500, supportVisualScale: 0.02, sectionVisualScale: 0.02, loadVisualScale: 0.02 },
  { label: "500 - 1000", max: 1000, supportVisualScale: 0.01, sectionVisualScale: 0.01, loadVisualScale: 0.01 },
  { label: "1000 - 1500", max: 1500, supportVisualScale: 0.0067, sectionVisualScale: 0.0067, loadVisualScale: 0.0067 },
  { label: "1500 - 2000", max: 2000, supportVisualScale: 0.005, sectionVisualScale: 0.005, loadVisualScale: 0.005 },
];

/**
 * Converts real-world units into visual grid space
 */
export const getScaleFromRange = (max: number) => {
  return GRID_VISUAL_SIZE / max;
};

/**
 * Converts a real-world value into scaled grid position
 */
export const scaleToGrid = (value: number, scale: number) => {
  return value * scale;
};

/**
 * Gets the support visual scale for a given scale range max value
 */
export const getSupportVisualScale = (scaleRangeMax: number): number => {
  const range = SCALE_RANGES.find(r => r.max === scaleRangeMax);
  return range?.supportVisualScale ?? 1.0;
};

/**
 * Gets the section visual scale for a given scale range max value
 */
export const getSectionVisualScale = (scaleRangeMax: number): number => {
  const range = SCALE_RANGES.find(r => r.max === scaleRangeMax);
  return range?.sectionVisualScale ?? 1.0;
};

/**
 * Gets the load visual scale for a given scale range max value
 */
export const getLoadVisualScale = (scaleRangeMax: number): number => {
  const range = SCALE_RANGES.find(r => r.max === scaleRangeMax);
  return range?.loadVisualScale ?? 1.0;
};
